import { render, staticRenderFns } from "./invite-suppliers-modal.vue?vue&type=template&id=4e63ce10&"
import script from "./invite-suppliers-modal.vue?vue&type=script&lang=js&"
export * from "./invite-suppliers-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports